import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { rapidBoardEntryPoint } from '@atlassian/jira-spa-apps-rapid-board/entrypoint.tsx';

export const reportPageEntrypoint = createPageEntryPoint({
	main: rapidBoardEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
